import type { MenuItem } from '@/components/layout/header/interfaces';
import type { Bootstrap } from '@/data/user/bootstrap-data/interfaces';
import type { User } from '@/models/user';
import type { BootstrapContext } from '@/routes/protected-route/interfaces';
import { hasAccess } from '@/utils/user-permissions';

interface FilterArgs {
  user?: User;
  bootstrap?: Bootstrap;
  items: MenuItem[];
}

export interface ResolvedMenuItem extends Omit<
  MenuItem,
  'label' | 'path' | 'children'
> {
  label: string;
  path?: string;
}

export const filterMenu = ({
  user,
  bootstrap,
  items,
}: FilterArgs): ResolvedMenuItem[] => {
  const ctx: BootstrapContext = { user, bootstrap };

  return items
    .filter((item) =>
      hasAccess(ctx, {
        permissions: item.permissions,
        features: item.features,
        check: item.check,
      })
    )
    .map((item) => ({
      ...item,
      label: typeof item.label === 'function' ? item.label(ctx) : item.label,
      path: typeof item.path === 'function' ? item.path(ctx) : item.path,
    }));
};
